export default __webpack_public_path__ + "static/media/ownerrez_step5.f1007570.jpg";